import OWNER_ES from "../data/ownerEs.json";
import EN_ES from "../data/enEs.json";

export const OWNER_LANGS = ["zh", "en", "es"];
export const OWNER_LANG_LABEL = { zh: "中文", en: "EN", es: "ES" };
export const normOwnerLang = (l) => (OWNER_LANGS.includes(l) ? l : "zh");
const TOKEN = /"[^"]*"|\d+(?:\.\d+)?/g;

/* English UI string → Spanish (owner dictionary → global dictionary → templated match with numbers / quoted names → English fallback) */
export const esOf = (en) => {
  if (!en || typeof en !== "string") return en;
  const hit = OWNER_ES[en] || EN_ES[en];
  if (hit) return hit;
  const vals = [];
  const key = en.replace(TOKEN, (m) => { if (m.startsWith("\"")) { vals.push(m.slice(1, -1)); return "\"{n}\""; } vals.push(m); return "{n}"; });
  const tpl = key !== en && (OWNER_ES[key] || EN_ES[key]);
  if (!tpl) return en;
  let i = 0;
  return tpl.replace(/\{n\}/g, () => (i < vals.length ? vals[i++] : ""));
};

export const makeT = (lang) => (zh, en) => (lang === "zh" ? zh : lang === "es" ? esOf(en) : en);

/* Backend bilingual/trilingual summary fields */
export const pickSummary = (o, lang, keys = ["summaryZh", "summaryEn", "summaryEs"]) => {
  if (!o) return "";
  const [z, e, s] = keys;
  if (lang === "zh") return o[z] || o[e] || "";
  if (lang === "es") return o[s] || o[e] || o[z] || "";
  return o[e] || o[z] || "";
};

/* zh/en pairs coming from the backend (titleZh/titleEn …): in ES mode the zh field has already been localized server-side unless it still contains CJK */
export const pickPair = (zhVal, enVal, lang) => {
  if (lang === "zh") return zhVal;
  if (lang === "es") return zhVal && !/[\u4e00-\u9fff]/.test(zhVal) ? zhVal : esOf(enVal || zhVal);
  return enVal || zhVal;
};

export const readOwnerLang = () => normOwnerLang(localStorage.getItem("ali_owner_lang"));
export const storeOwnerLang = (l) => localStorage.setItem("ali_owner_lang", normOwnerLang(l));
